module.exports = "<h4>Thank you, we received your reply.</h4>"